import { ROUTE } from '@/routes/constants';
import { Clock } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

export default function AccessRestrictedPage() {
  const { t } = useTranslation();
  const startTime = import.meta.env.VITE_ALLOWED_START_TIME || '6:00';
  const endTime = import.meta.env.VITE_ALLOWED_END_TIME || '21:00';

  return (
    <div className="flex h-screen w-screen items-center justify-center bg-background-white">
      <div className="mx-4 max-w-md rounded-3xl border border-gray-100 bg-white p-10 text-center shadow-xl dark:border-gray-800 dark:bg-gray-900">
        <div className="mb-6 flex justify-center">
          <div className="rounded-full bg-amber-100 p-4">
            <Clock className="h-10 w-10 text-amber-600" />
          </div>
        </div>
        <h1 className="mb-4 text-2xl font-bold text-gray-900 dark:text-gray-100">
          {t('access-restricted.title')}
        </h1>
        <p className="mb-6 text-gray-600 dark:text-gray-400">
          {t('access-restricted.message', { startTime, endTime })}
        </p>
        <Link
          to={ROUTE.LOGIN}
          className="inline-block rounded-lg bg-gray-900 px-6 py-2 text-white hover:bg-gray-800"
        >
          {t('access-restricted.back-to-login')}
        </Link>
      </div>
    </div>
  );
}
